import { NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import { App } from '@df/core/app';
import { ImageModule } from '@df/module-image/image.module';
import { UgcImage } from '@df/ugc-image/ugc-image';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { compact } from 'lodash-es';
import { Product } from '../../../catalog/product/product.decorator';
import { ShellComponent } from '../../../ui/display/local-shell.component';
@Component({
    selector: 'ugc-image-item',
    templateUrl: './ugc-image-item.component.html',
    styleUrl: './ugc-image-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ImageModule, ShellComponent, ICmsClientModule, VimeoPlayerComponent, NgClass, NgStyle, TranslatePipe]
})
export class UgcImageItemComponent extends UiComponent implements OnChanges {
    @Input({ required: true })
    model!: UgcImage;

    @Input()
    shopTheLook = false;

    products?: Product<IProductDataV2>[];

    productResource = inject(ProductResource);

    app = inject(App);

    override ngOnChanges(changes: SimpleChanges): void {
        if (changes['model']) {
            const skus = compact(Array.isArray(this.model.data?.sku) ? this.model.data?.sku : [this.model.data?.sku])
            if (!!skus?.length) {
                this.productResource.find({ verbosity: 2, filter: { sku: { $in: skus } } }).then(result => {
                    this.products = (result as Product<IProductDataV2>[]).filter(i => i.isSalable());
                    this.detectChanges();
                });
            }
            this.detectChanges();
        }
        console.log(this)
    }

    get shopTheLookUnder(): boolean {
        return this.client.sizeId < 2;
    }
}
